import { PlusCircleIcon } from '@phosphor-icons/react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { GenericTable, Spinner } from '@/modules/common';
import { StyleItem } from '@/modules/styles/types';

import { AddEditStyleDialog } from './components/add-edit-style-dialog';
import { useStylesTab } from './hooks/use-styles';

export type StyleTabItem = Partial<StyleItem> & { styleId: string };

export function StylesTab() {
  const [addStyleModalOpen, setAddStyleModalOpen] = useState(false);
  const [selectedStyle, setSelectedStyle] = useState<StyleTabItem | null>(null);

  const {
    formattedStyles,
    columns,
    fields,
    stylesData,
    isFetching,
    onAdd,
    onEdit,
  } = useStylesTab();

  return (
    <div>
      {isFetching ? (
        <Spinner />
      ) : (
        <>
          <div>
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-semibold">Styles Table</h3>
              <Button
                disabled={isFetching}
                data-testid="add-style-button"
                onClick={() => setAddStyleModalOpen(true)}
                startIcon={<PlusCircleIcon size={16} />}
              >
                Add style
              </Button>
            </div>
            <GenericTable
              name="styles"
              key="styles-table"
              columns={columns}
              data={formattedStyles}
              emptyCellClassName="h-20"
              tableCellClassName="py-1"
              tableRowClassName="hover:bg-transparent"
              emptyTitle="No styles yet"
              emptyDescription="No styles added. Please add new style."
              onClick={(item) => {
                setSelectedStyle(item);
                setAddStyleModalOpen(true);
              }}
              disabledColumnsIdsToClick={['name', 'actions']}
              emptyButton={
                <Button
                  disabled={isFetching}
                  data-testid="add-style-button"
                  onClick={() => setAddStyleModalOpen(true)}
                  startIcon={<PlusCircleIcon size={16} />}
                >
                  Add style
                </Button>
              }
            >
              <p className="text-zinc-400 text-sm">
                All styles: {fields.length}
              </p>
            </GenericTable>
          </div>
          <AddEditStyleDialog
            isOpen={addStyleModalOpen}
            onOpenChange={(open) => {
              setAddStyleModalOpen(open);
              setSelectedStyle(null);
            }}
            stylesData={stylesData}
            selectedStyle={selectedStyle}
            onAdd={onAdd}
            onEdit={(style) => onEdit(style, selectedStyle)}
          />
        </>
      )}
    </div>
  );
}
